import {InjectionToken} from '@angular/core';
import {SoftlineObjectService} from '@softline/core';

export const SOFTLINE_PERMISSION_COUPON_CARD = 'COUPONCARD';
export const SOFTLINE_FEATURE_COUPON = 'coupon';
export const SOFTLINE_FEATURE_COUPON_DAILY_BALANCE = 'couponDailyBalance';
export const SOFTLINE_SERVICE_COUPON_CARD_TRANSACTION = new InjectionToken<SoftlineObjectService>('SOFTLINE_SERVICE_COUPON_CARD_TRANSACTION');
